// src/hooks/useNoIndexCheck.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useNoIndexCheck() {
  const location = useLocation();

  useEffect(() => {
    const currentUrl = window.location.href;

    fetch("/valid-urls.json")
      .then((res) => res.json())
      .then((validUrls) => {
        const shouldIndex = validUrls.includes(currentUrl);

        let metaTag = document.querySelector("meta[name='robots']");
        if (!metaTag) {
          metaTag = document.createElement("meta");
          metaTag.setAttribute("name", "robots");
          document.head.appendChild(metaTag);
        }

        metaTag.setAttribute("content", shouldIndex ? "index, follow" : "noindex, follow");
      })
      .catch((err) => {
        console.error("Error cargando valid-urls.json:", err);
      });
  }, [location.pathname, location.search]);
}
